import BaseIcon from './base-icon'
export default {
    install: function(Vue) {
        Vue.component('BaseIcon', BaseIcon)
    }
}